<template>
  <div>
    <div id="duplicateStudyConfirmationModal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="duplicate-study-modal-content">
          <div class="pt-10 pr-20 pl-20">
            <p class="modal-title text-center pt-20">Duplicate Study</p>
          </div>
          <div class="pt-18">
            <p style="padding: 0 30%">Choose a destination:</p>
            <div class="instance-selection-section">
              <div class="">
                <input id="currentInstance" type="radio" value="" checked="true" />
                <label for="currentInstance">Current instance</label>
              </div>
              <div class="">
                <input id="differentInstance" type="radio" disabled="true" value="Select a different instance" />
                <label for="differentInstance">Select a different instance</label>
              </div>
            </div>
          </div>
          <div class="btn-section mb-35">
            <button class="btn btn-md cancel-btn" v-on:click="closeModal('duplicateStudyConfirmationModal')">
              Cancel
            </button>
            <button class="btn btn-md confirm-btn" v-on:click.stop="duplicateStudy()">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Certificate of duplicated study - Starts -->
    <div v-show="selectedCertificateStudy.duplicateStudyCertificate" ref="certificateToDownload" id="downloaded-certificate">
      <div class="heading ">Certificate of Study Duplication</div>
      <div>
        <span>Study ID: </span>
        <span>{{ showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "studyId") }}</span>
      </div>
      <div>
        <span>Study Name: </span>
        <span>{{ showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "studyName") }}</span>
      </div>
      <div class="content">
        This document certifies that this study is a duplicate and has been copied from another study.
      </div>
      <div>
        <span>Copy date and time (in UTC format): </span>
        <span> {{ showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "copiedTime") | dateInUTC }}</span>
      </div>
      <div>
        <span>Copied from Study ID: </span>
        <span> {{ showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "originalStudyId") }}</span>
      </div>
      <div>
        <span>Copied from Study Name: </span>
        <span> {{ showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "originalStudyName") }}</span>
      </div>
      <div>
        <span>Copied by: </span>
        <span> {{ `${showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "firstName")} ${showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "lastName")}, ${getUserRole(showDataOfKeys(selectedCertificateStudy.duplicateStudyCertificate, "userRole"))}` }}</span>
      </div>
    </div>
    <!-- Certificate of duplicated study - Ends -->
  </div>
</template>
<script>
import swal from "sweetalert2";
import toastr from "toastr";
import html2pdf from "html2pdf.js";

export default {
  name: "duplicateStudy",
  data() {
    return {
      downloadCertificateData: null,
      selectedCertificateStudy: {}
    };
  },
  props: {
    selectedStudy: {
      type: Object,
      default: null
    }
  },
  watch: {
    downloadCertificateData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.generatePDF();
        }
      }
    }
  },
  methods: {
    duplicateStudy() {
      swal({
        title: "You are about to copy this study. Would you like to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4c8ce4",
        cancelButtonColor: "#b8c7ce",
        confirmButtonText: "Yes, duplicate the study",
        cancelButtonText: "No, do not duplicate the study",
        allowOutsideClick: false
      }).then(({ dismiss }) => {
        if (dismiss !== "cancel") {
          this.closeModal("duplicateStudyConfirmationModal");
          this.$api.saveDuplicateStudy(this.selectedStudy.studyId).then(
            response => {
              this.setStudyDuplicationInProgress(true);
              this.setToastrTimeoutInMilisec(15000);
              toastr.success(response.bodyText);
              /* this.selectedStudy = {}; */
              const _this = this;
              setTimeout(() => {
                _this.setToastrTimeoutInMilisec(2000);
                _this.getAllStudies();
              }, 15000);
            },
            error => {
              this.closeModal("duplicateStudyConfirmationModal");
              toastr.error(error.body ? error.body.message : "Error while duplicating the study details.");
            }
          );
        }
      });
    },
    setToastrTimeoutInMilisec(time) {
      toastr.options.timeOut = time;
      toastr.options.extendedTimeOut = time;
    },
    closeModal(modal) {
      window.$("#" + modal).modal("hide");
    },
    getAllStudies() {
      this.$emit("getStudyList");
    },
    setStudyDuplicationInProgress(data) {
      this.$emit("duplicationInProgress", data);
    },
    downloadCertificate(study) {
      this.selectedCertificateStudy = study;
      this.downloadCertificateData = this.$refs.certificateToDownload.innerHTML;
    },
    generatePDF() {
      const opt = {
        margin: 1,
        filename: "Certificate.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(this.$refs.certificateToDownload, opt).then(() => {
        toastr.success("Duplicated study certificate downloaded successfully.");
        this.resetDataProperties();
      });
    },
    showDataOfKeys(obj, key) {
      return obj && obj[key];
    },
    getUserRole(key) {
      if (!key) {
        return "";
      } else if (key.toLowerCase() === "system admin") {
        return "Platform Admin";
      } else if (key.toLowerCase() === "study admin") {
        return "Study Admin";
      } else {
        return "";
      }
    },
    resetDataProperties() {
      this.selectedCertificateStudy = {};
      this.downloadCertificateData = null;
    }
  }
};
</script>
<style scoped lang="scss">
#duplicateStudyConfirmationModal {
  .modal-dialog {
    position: relative;
    width: 477px;
    margin: 0.5rem;
    pointer-events: none;
  }
  .duplicate-study-modal-content {
    position: relative;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    cursor: default;

    .modal-title {
      font-family: RobotoRegular;
      font-size: 18px;
      font-weight: bold;
      color: #666669;
    }
  }

  .btn-block {
    margin-top: 0px !important;
  }

  .instance-selection-section {
    padding: 0 30%;

    & label {
      margin-left: 5px;
    }
  }

  #differentInstance + label {
    color: #d9d9d9;
  }

  .btn-section {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 20px 0;
    padding: 0px 18%;
  }

  .cancel-btn {
    padding-left: 37px;
    padding-right: 37px;
    color: #4a4a4a;
    border-radius: 100px;
    background-color: #e0e0e0 !important;
    font-family: RobotoRegular;
    font-size: 14px;
    cursor: pointer;
  }

  .confirm-btn {
    padding-left: 37px;
    padding-right: 37px;
    background-color: #4c8ce4 !important;
    color: #ffffff !important;
    border-radius: 100px !important;
    font-family: RobotoRegular;
    font-size: 14px;
    cursor: pointer;
  }
}
#downloaded-certificate {
  margin: 30px !important;
  div {
    font-size: 16px;
    margin-top: 12px;
    margin-right: 12px;
    color: #000;
    font-family: "Times New Roman", Times, serif;
    & > span:first-child {
      margin-right: 2px;
    }
  }
  & .heading {
    text-align: center !important;
    font-size: 19px !important;
    font-weight: 600 !important;
    margin-bottom: 20px;
  }
  & .content {
    font-style: italic;
    margin: 35px 0;
  }
}
</style>
